import { Popup } from 'react-map-gl/mapbox'
import type { PopoverInfo } from '../../types'
import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { formatters } from '@/utils/intl/dateTimeFormatters'
import { startCase } from 'lodash'
import { PopoverRow } from './PoiPopover'
import type { ProductMovement } from '@/components/OrderDispatch/DriverTracking/types'

export function LoadDropPopover({ hoverInfo }: { hoverInfo: PopoverInfo | null }) {
  if (!hoverInfo || hoverInfo.popoverType !== 'load-drop') {
    return null
  }
  let productMovements = [] as ProductMovement[]
  try {
    productMovements = JSON.parse(hoverInfo.productMovements || '[]')
  } catch (error) {
    console.error('Error parsing product movements:', error)
  }

  return (
    <Popup
      longitude={hoverInfo.lon}
      latitude={hoverInfo.lat}
      closeButton={false}
      closeOnClick={false}
      anchor='bottom'
      offset={[0, -7]}
      style={{ minWidth: '200px' }}
      className='mapbox-popover'
    >
      <Vertical gap={4}>
        <Texto category='h4' appearance='hint'>
          {startCase(hoverInfo.action.slice(0, 4))}
        </Texto>
        <PopoverRow label='Location Name' value={hoverInfo.name} />
        <PopoverRow
          label='Products'
          value={
            <Horizontal style={{ flexWrap: 'wrap', gap: 4 }}>
              {productMovements.map((movement, index) => (
                <Horizontal key={index} style={{ borderRadius: 4, backgroundColor: 'var(--gray-200)' }}>
                  <Texto className='px-1' style={{ backgroundColor: 'black', color: 'white' }}>
                    {(movement.gross_volume || movement.dropped_volume).toString().slice(0, 2)}
                  </Texto>
                  <Texto className='px-1' style={{ color: 'black' }}>
                    {movement.product_name}
                  </Texto>
                </Horizontal>
              ))}
            </Horizontal>
          }
        />
        <PopoverRow label='Timestamp' value={formatters.DATE_TIME(hoverInfo.timestamp, hoverInfo.timezone)} />
      </Vertical>
    </Popup>
  )
}
